module.exports = __webpack_public_path__ + "static/media/sort.f34da5a1.svg";